<template>
  <v-card elevation="0" class="post-card mb-3">
    <v-tabs v-model="tab" slider-color="#f78166">
      <!-- tabs  -->
      <!-- post content  -->
      <v-tab v-if="!storyContant" value="one" class="mr-5 position-relative">
        <span class="mr-3">Content</span>
        <span
          @click="customizeByPlatformType()"
          style="cursor: pointer; position: absolute; right: 6px; top: 6px"
        >
          <Close style="width: 0.8rem; height: 1.5rem" />
        </span>
      </v-tab>
      <!-- reel story content  -->
      <v-tab
        v-if="storyContant"
        value="reelStoryContent"
        class="mr-5 position-relative"
      >
        <span class="mr-3">Content</span>
        <span
          @click="customizeByPlatformType()"
          style="cursor: pointer; position: absolute; right: 6px; top: 6px"
        >
          <Close style="width: 0.8rem; height: 1.5rem" />
        </span>
      </v-tab>
      <!-- facebook post  -->
      <v-tab
        value="two"
        v-if="
          !storyContant && selectedTypes['facebook'].find((el) => el === 'post')
        "
        class="mr-2"
        selected-class="dddddddddd"
      >
        <div class="eer"></div>
        <span style="margin-right: 3px">
          <FacebookIcon
            :fill-color="
              tab === 'two' ? 'url(#paint0_linear_34_2022)' : '#4D4D4D'
            "
          />
        </span>
        Post
      </v-tab>
      <!-- instagram post -->
      <v-tab
        value="three"
        v-if="
          !storyContant &&
          selectedTypes['instagram'].find((el) => el === 'post')
        "
        class="mr-2"
      >
        <span style="margin-right: 3px">
          <InstgramIcon v-if="tab === 'three'" />
          <Instgramdisactive v-else />
        </span>
        Post
      </v-tab>
      <!-- snap post -->
      <v-tab
        value="five"
        v-if="
          !storyContant && selectedTypes['snapchat'].find((el) => el === 'post')
        "
        class="mr-2"
      >
        <img
          :src="
            tab === 'five'
              ? require('@/assets/soft-ware-img/snapchat-icoon-ccampaign.svg')
              : require('@/assets/soft-ware-img/Component-67.svg')
          "
          style="margin-right: 3px"
          alt=""
        />
        <span style="margin-right: 3px">
          <Snapactive v-if="tab === 'five'" />
          <Snapdisactive v-else />
        </span>
        Post
      </v-tab>

      <!-- facebook story  -->
      <v-tab
        v-if="
          storyContant && selectedTypes['facebook'].find((el) => el === 'story')
        "
        value="six"
        class="mr-2"
      >
        <span style="margin-right: 3px">
          <FacebookIcon
            :fill-color="
              tab === 'six' ? 'url(#paint0_linear_34_2022)' : '#4D4D4D'
            "
          />
        </span>
        Story</v-tab
      >
      <!-- facebook reel  -->
      <v-tab
        v-if="
          storyContant && selectedTypes['facebook'].find((el) => el === 'reel')
        "
        value="seven"
        class="mr-2"
      >
        <span style="margin-right: 3px">
          <FacebookIcon
            :fill-color="
              tab === 'seven' ? 'url(#paint0_linear_34_2022)' : '#4D4D4D'
            "
          />
        </span>
        Reel</v-tab
      >
      <!-- instagram story  -->
      <v-tab
        v-if="
          storyContant &&
          selectedTypes['instagram'].find((el) => el === 'story')
        "
        value="eight"
        class="mr-2"
      >
        <span style="margin-right: 3px">
          <InstgramIcon v-if="tab === 'eight'" />
          <Instgramdisactive v-else />
        </span>
        Story</v-tab
      >
      <!-- instagram reel -->
      <v-tab
        v-if="
          storyContant && selectedTypes['instagram'].find((el) => el === 'reel')
        "
        value="nine"
        class="mr-2"
      >
        <span style="margin-right: 3px">
          <InstgramIcon v-if="tab === 'nine'" />
          <Instgramdisactive v-else />
        </span>
        Reel</v-tab
      >
      <!-- snapchat story  -->
      <v-tab
        v-if="
          storyContant && selectedTypes['snapchat'].find((el) => el === 'story')
        "
        value="eleven"
        class="mr-2"
      >
        <span style="margin-right: 3px">
          <Snapactive v-if="tab === 'eleven'" />
          <Snapdisactive v-else />
        </span>
        Story
      </v-tab>
    </v-tabs>
    <v-card-text elevation="0" class="ma-0">
      <v-tabs-window v-model="tab" elevation="0">
        <v-tabs-window-item
          value="one"
          class="contant-social-post-default positon-relative"
        >
          <div class="border-0 card positon-relative">
            <textarea
              :disabled="!store?.getCarouselSlider?.length"
              placeholder="Write the content that you will use as a template on the rest of the platforms"
              name=""
              id=""
              rows="15"
              maxlength="2500"
              v-model="allPostContent"
              class=""
              ref="textarea"
            ></textarea>
            <div v-if="mediaFilsPost" class="image-preview-overlay">
              <div
                class="image-preview-container"
                v-for="(media, index) in mediaFilsPost"
                :key="index"
              >
                <img :src="media.preview" alt="Preview" />
                <button
                  class="remove-image"
                  @click="removeImage(index, mediaFilsPost)"
                >
                  ×
                </button>
              </div>
            </div>
            <div
              class="textarea-actions d-flex align-center justify-space-between"
            >
              <div class="btn-groups d-flex align-start ga-3">
                <ImageMenu
                  :disabled="!store?.getCarouselSlider?.length"
                  @fileSelected="
                    (res) => handleFileSelected(res, 'allPostContent')
                  "
                  @driveSelect="handleDriveSelect"
                  @editImage="handleEditImage"
                />
                <button
                  class="btn-post"
                  :disabled="!store?.getCarouselSlider?.length"
                  @click="toggleEmojiPicker"
                >
                  <img
                    src="@/assets/soft-ware-img/happy-face_8376596 1.svg"
                    alt=""
                  />
                </button>
                <button
                  :disabled="!store?.getCarouselSlider?.length"
                  class="btn-post"
                  @click="all_post_dialog = true"
                >
                  <Linkicon />
                </button>
              </div>
              <!-- Link review section -->
              <div class="word-length">
                <span> {{ longOfText }} </span> /
                <span>2500</span>
              </div>
            </div>
            <v-dialog
              class="links-dialog"
              v-model="all_post_dialog"
              width="400px"
            >
              <v-card max-width="400" title="Add link">
                <div class="add-link-dialog d-flex flex-column w-100 pa-3">
                  <input
                    v-model="newLinkName"
                    placeholder="Enter link name"
                    type="text"
                    class="add-link-input"
                  />
                  <input
                    v-model="newLinkHref"
                    placeholder="Enter link URL"
                    type="url"
                    class="add-link-input"
                  />
                </div>
                <div v-if="links.length" class="all-links pa-2">
                  <h4>Links:</h4>
                  <ul>
                    <li
                      v-for="(link, index) in store.getLink('', 'post')"
                      :key="index"
                    >
                      <a
                        :href="link.href"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {{ link.name }}
                      </a>
                      <button
                        @click="removeLink(index, 'customize', '', 'post')"
                      >
                        Remove
                      </button>
                    </li>
                  </ul>
                </div>
                <template v-slot:actions>
                  <button @click="addCustomizationLink('all_posts')">
                    Add Link
                  </button>
                </template>
              </v-card>
            </v-dialog>
          </div>

          <div v-if="showEmojiPicker" class="emoji-picker-wrapper">
            <emoji-picker
              @emoji-click="(event) => onEmojiClick(event, 'allPostContent')"
            ></emoji-picker>
          </div>
        </v-tabs-window-item>
        <v-tabs-window-item
          value="reelStoryContent"
          class="contant-social-post-default positon-relative"
        >
          <div class="border-0 card positon-relative">
            <textarea
              placeholder="Write the content that you will use as a template on the rest of the platforms"
              name=""
              id=""
              rows="15"
              maxlength="2500"
              v-model="allReelStoryContent"
              class=""
              ref="textarea"
            ></textarea>
            <div v-if="mediaFilsPost" class="image-preview-overlay">
              <div
                class="image-preview-container"
                v-for="(media, index) in mediaFilsPost"
                :key="index"
              >
                <img :src="media.preview" alt="Preview" />
                <button
                  class="remove-image"
                  @click="removeImage(index, mediaFilsPost)"
                >
                  ×
                </button>
              </div>
            </div>
            <div
              class="textarea-actions d-flex align-center justify-space-between"
            >
              <div class="btn-groups d-flex align-start ga-3">
                <ImageMenu
                  @fileSelected="
                    (res) => handleFileSelected(res, 'allReelStoryContent')
                  "
                  @driveSelect="handleDriveSelect"
                  @editImage="handleEditImage"
                />
                <button class="btn-post" @click="toggleEmojiPicker">
                  <img
                    src="@/assets/soft-ware-img/happy-face_8376596 1.svg"
                    alt=""
                  />
                </button>
                <button class="btn-post" @click="all_reel_story_dialog = true">
                  <Linkicon />
                </button>
              </div>
              <!-- Link review section -->
              <div class="word-length">
                <span> {{ longOfText }} </span> /
                <span>2500</span>
              </div>
            </div>
            <v-dialog
              class="links-dialog"
              v-model="all_reel_story_dialog"
              width="400px"
            >
              <v-card max-width="400" title="Add link">
                <div class="add-link-dialog d-flex flex-column w-100 pa-3">
                  <input
                    v-model="newLinkName"
                    placeholder="Enter link name"
                    type="text"
                  />
                  <input
                    v-model="newLinkHref"
                    placeholder="Enter link URL"
                    type="url"
                  />
                </div>
                <div v-if="links.length" class="all-links pa-2">
                  <h4>Links:</h4>
                  <ul>
                    <li
                      v-for="(link, index) in store.getLink(
                        '',
                        'story_and_reel'
                      )"
                      :key="index"
                    >
                      <a
                        :href="link.href"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Link
                      </a>
                      <button
                        @click="
                          removeLink(index, 'customize', '', 'story_and_reel')
                        "
                      >
                        Remove
                      </button>
                    </li>
                  </ul>
                </div>
                <template v-slot:actions>
                  <button @click="addCustomizationLink('all_story_reel')">
                    Add Link
                  </button>
                </template>
              </v-card>
            </v-dialog>
          </div>

          <div v-if="showEmojiPicker" class="emoji-picker-wrapper">
            <emoji-picker
              @emoji-click="
                (event) => onEmojiClick(event, 'allReelStoryContent')
              "
            ></emoji-picker>
          </div>
        </v-tabs-window-item>
        <v-tabs-window-item value="two" class="contant-social-post-default">
          <div class="border-0 card positon-relative">
            <textarea
              placeholder="Write the content that you will use as a template on the rest of the platforms"
              name=""
              id=""
              rows="15"
              maxlength="2500"
              v-model="facebookPostContent"
              class=""
              ref="textarea"
            ></textarea>
            <div v-if="facebookPostMedia" class="image-preview-overlay">
              <div
                class="image-preview-container"
                v-for="(media, index) in facebookPostMedia"
                :key="index"
              >
                <img :src="media.preview" alt="Preview" />
                <button
                  class="remove-image"
                  @click="removeImage(index, facebookPostMedia)"
                >
                  ×
                </button>
              </div>
            </div>
            <div
              class="textarea-actions d-flex align-center justify-space-between"
            >
              <div class="btn-groups d-flex align-start ga-3">
                <ImageMenu
                  @fileSelected="
                    (res) => handleFileSelected(res, 'facebookPostContent')
                  "
                  @driveSelect="handleDriveSelect"
                  @editImage="handleEditImage"
                />
                <button class="btn-post" @click="toggleEmojiPicker">
                  <img
                    src="@/assets/soft-ware-img/happy-face_8376596 1.svg"
                    alt=""
                  />
                </button>
                <button class="btn-post" @click="facebook_post_dialog = true">
                  <Linkicon />
                </button>
              </div>
              <!-- Link review section -->
              <div class="word-length">
                <span> {{ longOfText }} </span> /
                <span>2500</span>
              </div>
            </div>
            <v-dialog
              class="links-dialog"
              v-model="facebook_post_dialog"
              width="400px"
            >
              <v-card max-width="400" title="Add link">
                <div class="add-link-dialog d-flex flex-column w-100 pa-3">
                  <input
                    v-model="newLinkName"
                    placeholder="Enter link name"
                    type="text"
                  />
                  <input
                    v-model="newLinkHref"
                    placeholder="Enter link URL"
                    type="url"
                  />
                </div>
                <div v-if="links.length" class="all-links pa-2">
                  <h4>Links:</h4>
                  <ul>
                    <li
                      v-for="(link, index) in store.getLink('facebook', 'post')"
                      :key="index"
                    >
                      <a :href="link" target="_blank" rel="noopener noreferrer">
                        link
                      </a>
                      <button
                        @click="
                          removeLink(index, 'customize', 'facebook', 'post')
                        "
                      >
                        Remove
                      </button>
                    </li>
                  </ul>
                </div>
                <template v-slot:actions>
                  <button @click="addCustomizationLink('facebook_post')">
                    Add Link
                  </button>
                </template>
              </v-card>
            </v-dialog>
          </div>
          <div v-if="showEmojiPicker" class="emoji-picker-wrapper">
            <emoji-picker
              @emoji-click="
                (event) => onEmojiClick(event, 'facebookPostContent')
              "
            ></emoji-picker>
          </div>
        </v-tabs-window-item>
        <v-tabs-window-item value="three" class="contant-social-post-default">
          <div class="border-0 card positon-relative">
            <textarea
              placeholder="Write the content that you will use as a template on the rest of the platforms"
              name=""
              id=""
              rows="15"
              maxlength="2500"
              v-model="instagramPostContent"
              class=""
              ref="textarea"
            ></textarea>
            <div v-if="instagramPostMedia" class="image-preview-overlay">
              <div
                class="image-preview-container"
                v-for="(media, index) in instagramPostMedia"
                :key="index"
              >
                <img :src="media.preview" alt="Preview" />
                <button
                  class="remove-image"
                  @click="removeImage(index, instagramPostMedia)"
                >
                  ×
                </button>
              </div>
            </div>
            <div
              class="textarea-actions d-flex align-center justify-space-between"
            >
              <div class="btn-groups d-flex align-start ga-3">
                <ImageMenu
                  @fileSelected="
                    (res) => handleFileSelected(res, 'instagramPostContent')
                  "
                  @driveSelect="handleDriveSelect"
                  @editImage="handleEditImage"
                />
                <button class="btn-post" @click="toggleEmojiPicker">
                  <img
                    src="@/assets/soft-ware-img/happy-face_8376596 1.svg"
                    alt=""
                  />
                </button>
                <button class="btn-post" @click="instagram_post_dialog = true">
                  <Linkicon />
                </button>
              </div>
              <!-- Link review section -->
              <div class="word-length">
                <span> {{ longOfText }} </span> /
                <span>2500</span>
              </div>
            </div>
            <v-dialog
              class="links-dialog"
              v-model="instagram_post_dialog"
              width="400px"
            >
              <v-card max-width="400" title="Add link">
                <div class="add-link-dialog d-flex flex-column w-100 pa-3">
                  <input
                    v-model="newLinkName"
                    placeholder="Enter link name"
                    type="text"
                  />
                  <input
                    v-model="newLinkHref"
                    placeholder="Enter link URL"
                    type="url"
                  />
                </div>
                <div v-if="links.length" class="all-links pa-2">
                  <h4>Links:</h4>
                  <ul>
                    <li
                      v-for="(link, index) in store.getLink(
                        'instagram',
                        'post'
                      )"
                      :key="index"
                    >
                      <a
                        :href="link.href"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {{ link.name }}
                      </a>
                      <button
                        @click="
                          removeLink(index, 'customize', 'instagram', 'post')
                        "
                      >
                        Remove
                      </button>
                    </li>
                  </ul>
                </div>
                <template v-slot:actions>
                  <button @click="addCustomizationLink('instagram_post')">
                    Add Link
                  </button>
                </template>
              </v-card>
            </v-dialog>
          </div>
          <div v-if="showEmojiPicker" class="emoji-picker-wrapper">
            <emoji-picker
              @emoji-click="
                (event) => onEmojiClick(event, 'instagramPostContent')
              "
            ></emoji-picker>
          </div>
        </v-tabs-window-item>
        <v-tabs-window-item value="five" class="contant-social-post-default">
          <div class="border-0 card positon-relative">
            <textarea
              placeholder="Write the content that you will use as a template on the rest of the platforms"
              name=""
              id=""
              rows="15"
              maxlength="2500"
              v-model="snapChatPostContent"
              class=""
              ref="textarea"
            ></textarea>
            <div v-if="snapChatPostMedia" class="image-preview-overlay">
              <div
                class="image-preview-container"
                v-for="(media, index) in snapChatPostMedia"
                :key="index"
              >
                <img :src="media.preview" alt="Preview" />
                <button
                  class="remove-image"
                  @click="removeImage(index, snapChatPostMedia)"
                >
                  ×
                </button>
              </div>
            </div>
            <div
              class="textarea-actions d-flex align-center justify-space-between"
            >
              <div class="btn-groups d-flex align-start ga-3">
                <ImageMenu
                  @fileSelected="
                    (res) => handleFileSelected(res, 'snapChatPostContent')
                  "
                  @driveSelect="handleDriveSelect"
                  @editImage="handleEditImage"
                />
                <button class="btn-post" @click="toggleEmojiPicker">
                  <img
                    src="@/assets/soft-ware-img/happy-face_8376596 1.svg"
                    alt=""
                  />
                </button>
                <button class="btn-post" @click="snapchat_post_dialog = true">
                  <Linkicon />
                </button>
              </div>
              <!-- Link review section -->
              <div class="word-length">
                <span> {{ longOfText }} </span> /
                <span>2500</span>
              </div>
            </div>
            <v-dialog
              class="links-dialog"
              v-model="snapchat_post_dialog"
              width="400px"
            >
              <v-card max-width="400" title="Add link">
                <div class="add-link-dialog d-flex flex-column w-100 pa-3">
                  <input
                    v-model="newLinkName"
                    placeholder="Enter link name"
                    type="text"
                  />
                  <input
                    v-model="newLinkHref"
                    placeholder="Enter link URL"
                    type="url"
                  />
                </div>
                <div v-if="links.length" class="all-links pa-2">
                  <h4>Links:</h4>
                  <ul>
                    <li
                      v-for="(link, index) in store.getLink('snapchat', 'post')"
                      :key="index"
                    >
                      <a
                        :href="link.href"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {{ link.name }}
                      </a>
                      <button
                        @click="
                          removeLink(index, 'customize', 'snapchat', 'post')
                        "
                      >
                        Remove
                      </button>
                    </li>
                  </ul>
                </div>
                <template v-slot:actions>
                  <button @click="addCustomizationLink('snapchat_post')">
                    Add Link
                  </button>
                </template>
              </v-card>
            </v-dialog>
          </div>
          <div v-if="showEmojiPicker" class="emoji-picker-wrapper">
            <emoji-picker
              @emoji-click="
                (event) => onEmojiClick(event, 'snapChatPostContent')
              "
            ></emoji-picker>
          </div>
        </v-tabs-window-item>
        <v-tabs-window-item value="six" class="contant-social-post-default">
          <div class="border-0 card positon-relative">
            <textarea
              placeholder="Write the content that you will use as a template on the rest of the platforms"
              name=""
              id=""
              rows="15"
              maxlength="2500"
              v-model="facebookStoryContent"
              class=""
              ref="textarea"
            ></textarea>
            <div v-if="facebookStoryMedia" class="image-preview-overlay">
              <div
                class="image-preview-container"
                v-for="(media, index) in facebookStoryMedia"
                :key="index"
              >
                <img :src="media.preview" alt="Preview" />
                <button
                  class="remove-image"
                  @click="removeImage(index, facebookStoryMedia)"
                >
                  ×
                </button>
              </div>
            </div>
            <div
              class="textarea-actions d-flex align-center justify-space-between"
            >
              <div class="btn-groups d-flex align-start ga-3">
                <ImageMenu
                  @fileSelected="
                    (res) => handleFileSelected(res, 'facebookStoryContant')
                  "
                  @driveSelect="handleDriveSelect"
                  @editImage="handleEditImage"
                />
                <button class="btn-post" @click="toggleEmojiPicker">
                  <img
                    src="@/assets/soft-ware-img/happy-face_8376596 1.svg"
                    alt=""
                  />
                </button>
                <button class="btn-post" @click="facebook_story_dialog = true">
                  <Linkicon />
                </button>
              </div>
              <!-- Link review section -->
              <div class="word-length">
                <span> {{ longOfText }} </span> /
                <span>2500</span>
              </div>
            </div>
            <v-dialog
              class="links-dialog"
              v-model="facebook_story_dialog"
              width="400px"
            >
              <v-card max-width="400" title="Add link">
                <div class="add-link-dialog d-flex flex-column w-100 pa-3">
                  <input
                    v-model="newLinkName"
                    placeholder="Enter link name"
                    type="text"
                  />
                  <input
                    v-model="newLinkHref"
                    placeholder="Enter link URL"
                    type="url"
                  />
                </div>
                <div v-if="links.length" class="all-links pa-2">
                  <h4>Links:</h4>
                  <ul>
                    <li
                      v-for="(link, index) in store.getLink(
                        'facebook',
                        'story'
                      )"
                      :key="index"
                    >
                      <a
                        :href="link.href"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {{ link.name }}
                      </a>
                      <button
                        @click="
                          removeLink(index, 'customize', 'facebook', 'story')
                        "
                      >
                        Remove
                      </button>
                    </li>
                  </ul>
                </div>
                <template v-slot:actions>
                  <button @click="addCustomizationLink('facebook_story')">
                    Add Link
                  </button>
                </template>
              </v-card>
            </v-dialog>
          </div>
          <div v-if="showEmojiPicker" class="emoji-picker-wrapper">
            <emoji-picker
              @emoji-click="
                (event) => onEmojiClick(event, 'facebookStoryContent')
              "
            ></emoji-picker>
          </div>
        </v-tabs-window-item>
        <v-tabs-window-item value="seven" class="contant-social-post-default">
          <div class="border-0 card positon-relative">
            <textarea
              placeholder="Write the content that you will use as a template on the rest of the platforms"
              name=""
              id=""
              rows="15"
              maxlength="2500"
              v-model="facebookReelContent"
              class=""
              ref="textarea"
            ></textarea>
            <div v-if="facebookReelMedia" class="image-preview-overlay">
              <div
                class="image-preview-container"
                v-for="(media, index) in facebookReelMedia"
                :key="index"
              >
                <img :src="media.preview" alt="Preview" />
                <button
                  class="remove-image"
                  @click="removeImage(index, facebookReelMedia)"
                >
                  ×
                </button>
              </div>
            </div>
            <div
              class="textarea-actions d-flex align-center justify-space-between"
            >
              <div class="btn-groups d-flex align-start ga-3">
                <ImageMenu
                  @fileSelected="
                    (res) => handleFileSelected(res, 'facebookReelContent')
                  "
                  @driveSelect="handleDriveSelect"
                  @editImage="handleEditImage"
                />
                <button class="btn-post" @click="toggleEmojiPicker">
                  <img
                    src="@/assets/soft-ware-img/happy-face_8376596 1.svg"
                    alt=""
                  />
                </button>
                <button class="btn-post" @click="facebook_reel_dialog = true">
                  <Linkicon />
                </button>
              </div>
              <!-- Link review section -->
              <div class="word-length">
                <span> {{ longOfText }} </span> /
                <span>2500</span>
              </div>
            </div>
            <v-dialog
              class="links-dialog"
              v-model="facebook_reel_dialog"
              width="400px"
            >
              <v-card max-width="400" title="Add link">
                <div class="add-link-dialog d-flex flex-column w-100 pa-3">
                  <input
                    v-model="newLinkName"
                    placeholder="Enter link name"
                    type="text"
                  />
                  <input
                    v-model="newLinkHref"
                    placeholder="Enter link URL"
                    type="url"
                  />
                </div>
                <div v-if="links.length" class="all-links pa-2">
                  <h4>Links:</h4>
                  <ul>
                    <li
                      v-for="(link, index) in store.getLink('facebook', 'reel')"
                      :key="index"
                    >
                      <a
                        :href="link.href"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {{ link.name }}
                      </a>
                      <button
                        @click="
                          removeLink(index, 'customize', 'facebook', 'reel')
                        "
                      >
                        Remove
                      </button>
                    </li>
                  </ul>
                </div>
                <template v-slot:actions>
                  <button @click="addCustomizationLink('facebook_reel')">
                    Add Link
                  </button>
                </template>
              </v-card>
            </v-dialog>
          </div>
          <div v-if="showEmojiPicker" class="emoji-picker-wrapper">
            <emoji-picker
              @emoji-click="
                (event) => onEmojiClick(event, 'facebookReelContent')
              "
            ></emoji-picker>
          </div>
        </v-tabs-window-item>
        <v-tabs-window-item value="eight" class="contant-social-post-default">
          <div class="border-0 card positon-relative">
            <textarea
              placeholder="Write the content that you will use as a template on the rest of the platforms"
              name=""
              id=""
              rows="15"
              maxlength="2500"
              v-model="instagramStoryContent"
              class=""
              ref="textarea"
            ></textarea>
            <div v-if="instagramStoryMedia" class="image-preview-overlay">
              <div
                class="image-preview-container"
                v-for="(media, index) in instagramStoryMedia"
                :key="index"
              >
                <img :src="media.preview" alt="Preview" />
                <button
                  class="remove-image"
                  @click="removeImage(index, instagramStoryMedia)"
                >
                  ×
                </button>
              </div>
            </div>
            <div
              class="textarea-actions d-flex align-center justify-space-between"
            >
              <div class="btn-groups d-flex align-start ga-3">
                <ImageMenu
                  @fileSelected="
                    (res) => handleFileSelected(res, 'instagramStoryContent')
                  "
                  @driveSelect="handleDriveSelect"
                  @editImage="handleEditImage"
                />
                <button class="btn-post" @click="toggleEmojiPicker">
                  <img
                    src="@/assets/soft-ware-img/happy-face_8376596 1.svg"
                    alt=""
                  />
                </button>
                <button class="btn-post" @click="instagram_story_dialog = true">
                  <Linkicon />
                </button>
              </div>
              <!-- Link review section -->
              <div class="word-length">
                <span> {{ longOfText }} </span> /
                <span>2500</span>
              </div>
            </div>
            <v-dialog
              class="links-dialog"
              v-model="instagram_story_dialog"
              width="400px"
            >
              <v-card max-width="400" title="Add link">
                <div class="add-link-dialog d-flex flex-column w-100 pa-3">
                  <input
                    v-model="newLinkName"
                    placeholder="Enter link name"
                    type="text"
                  />
                  <input
                    v-model="newLinkHref"
                    placeholder="Enter link URL"
                    type="url"
                  />
                </div>
                <div v-if="links.length" class="all-links pa-2">
                  <h4>Links:</h4>
                  <ul>
                    <li
                      v-for="(link, index) in store.getLink(
                        'instagram',
                        'story'
                      )"
                      :key="index"
                    >
                      <a
                        :href="link.href"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {{ link.name }}
                      </a>
                      <button
                        @click="
                          removeLink(index, 'customize', 'instagram', 'story')
                        "
                      >
                        Remove
                      </button>
                    </li>
                  </ul>
                </div>
                <template v-slot:actions>
                  <button @click="addCustomizationLink('instagram_story')">
                    Add Link
                  </button>
                </template>
              </v-card>
            </v-dialog>
          </div>
          <div v-if="showEmojiPicker" class="emoji-picker-wrapper">
            <emoji-picker
              @emoji-click="
                (event) => onEmojiClick(event, 'instagramStoryContent')
              "
            ></emoji-picker>
          </div>
        </v-tabs-window-item>
        <v-tabs-window-item value="nine" class="contant-social-post-default">
          <div class="border-0 card positon-relative">
            <textarea
              placeholder="Write the content that you will use as a template on the rest of the platforms"
              name=""
              id=""
              rows="15"
              maxlength="2500"
              v-model="instagramReelContent"
              class=""
              ref="textarea"
            ></textarea>
            <div v-if="instagramReelMedia" class="image-preview-overlay">
              <div
                class="image-preview-container"
                v-for="(media, index) in instagramReelMedia"
                :key="index"
              >
                <img :src="media.preview" alt="Preview" />
                <button
                  class="remove-image"
                  @click="removeImage(index, instagramReelMedia)"
                >
                  ×
                </button>
              </div>
            </div>
            <div
              class="textarea-actions d-flex align-center justify-space-between"
            >
              <div class="btn-groups d-flex align-start ga-3">
                <ImageMenu
                  @fileSelected="
                    (res) => handleFileSelected(res, 'instagramReelContent')
                  "
                  @driveSelect="handleDriveSelect"
                  @editImage="handleEditImage"
                />
                <button class="btn-post" @click="toggleEmojiPicker">
                  <img
                    src="@/assets/soft-ware-img/happy-face_8376596 1.svg"
                    alt=""
                  />
                </button>
                <button class="btn-post" @click="instagram_reel_dialog = true">
                  <Linkicon />
                </button>
              </div>
              <!-- Link review section -->
              <div class="word-length">
                <span> {{ longOfText }} </span> /
                <span>2500</span>
              </div>
            </div>
            <v-dialog
              class="links-dialog"
              v-model="instagram_reel_dialog"
              width="400px"
            >
              <v-card max-width="400" title="Add link">
                <div class="add-link-dialog d-flex flex-column w-100 pa-3">
                  <input
                    v-model="newLinkName"
                    placeholder="Enter link name"
                    type="text"
                  />
                  <input
                    v-model="newLinkHref"
                    placeholder="Enter link URL"
                    type="url"
                  />
                </div>
                <div v-if="links.length" class="all-links pa-2">
                  <h4>Links:</h4>
                  <ul>
                    <li
                      v-for="(link, index) in store.getLink(
                        'instagram',
                        'reel'
                      )"
                      :key="index"
                    >
                      <a
                        :href="link.href"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {{ link.name }}
                      </a>
                      <button
                        @click="
                          removeLink(index, 'customize', 'instagram', 'reel')
                        "
                      >
                        Remove
                      </button>
                    </li>
                  </ul>
                </div>
                <template v-slot:actions>
                  <button @click="addCustomizationLink('instagram_reel')">
                    Add Link
                  </button>
                </template>
              </v-card>
            </v-dialog>
          </div>
          <div v-if="showEmojiPicker" class="emoji-picker-wrapper">
            <emoji-picker
              @emoji-click="
                (event) => onEmojiClick(event, 'instagramReelContent')
              "
            ></emoji-picker>
          </div>
        </v-tabs-window-item>
        <v-tabs-window-item value="eleven" class="contant-social-post-default">
          <div class="border-0 card positon-relative">
            <textarea
              placeholder="Write the content that you will use as a template on the rest of the platforms"
              name=""
              id=""
              rows="15"
              maxlength="2500"
              v-model="snapChatStoryContent"
              class=""
              ref="textarea"
            ></textarea>
            <div v-if="snapchatStoryMedia" class="image-preview-overlay">
              <div
                class="image-preview-container"
                v-for="(media, index) in snapchatStoryMedia"
                :key="index"
              >
                <img :src="media.preview" alt="Preview" />
                <button
                  class="remove-image"
                  @click="removeImage(index, snapchatStoryMedia)"
                >
                  ×
                </button>
              </div>
            </div>
            <div
              class="textarea-actions d-flex align-center justify-space-between"
            >
              <div class="btn-groups d-flex align-start ga-3">
                <ImageMenu
                  @fileSelected="
                    (res) => handleFileSelected(res, 'snapchatStoryContent')
                  "
                  @driveSelect="handleDriveSelect"
                  @editImage="handleEditImage"
                />
                <button class="btn-post" @click="toggleEmojiPicker">
                  <img
                    src="@/assets/soft-ware-img/happy-face_8376596 1.svg"
                    alt=""
                  />
                </button>
                <button class="btn-post" @click="snapchat_story_dialog = true">
                  <Linkicon />
                </button>
              </div>
              <!-- Link review section -->
              <div class="word-length">
                <span> {{ longOfText }} </span> /
                <span>2500</span>
              </div>
            </div>
            <v-dialog
              class="links-dialog"
              v-model="snapchat_story_dialog"
              width="400px"
            >
              <v-card max-width="400" title="Add link">
                <div class="add-link-dialog d-flex flex-column w-100 pa-3">
                  <input
                    v-model="newLinkName"
                    placeholder="Enter link name"
                    type="text"
                  />
                  <input
                    v-model="newLinkHref"
                    placeholder="Enter link URL"
                    type="url"
                  />
                </div>
                <div v-if="links.length" class="all-links pa-2">
                  <h4>Links:</h4>
                  <ul>
                    <li
                      v-for="(link, index) in store.getLink(
                        'snapchat',
                        'story'
                      )"
                      :key="index"
                    >
                      <a
                        :href="link.href"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {{ link.name }}
                      </a>
                      <button
                        @click="
                          removeLink(index, 'customize', 'snapchat', 'story')
                        "
                      >
                        Remove
                      </button>
                    </li>
                  </ul>
                </div>
                <template v-slot:actions>
                  <button @click="addCustomizationLink('snapchat_story')">
                    Add Link
                  </button>
                </template>
              </v-card>
            </v-dialog>
          </div>
          <div v-if="showEmojiPicker" class="emoji-picker-wrapper">
            <emoji-picker
              @emoji-click="
                (event) => onEmojiClick(event, 'snapChatStoryContent')
              "
            ></emoji-picker>
          </div>
        </v-tabs-window-item>
      </v-tabs-window>
    </v-card-text>
  </v-card>
</template>

<script>
import ImageMenu from "./ImageMenu.vue";
import "emoji-picker-element";
import { publishPost } from "@/store/publishPost/publishPost.js";
import { mapState } from "pinia";
import Close from "@/components/icons/Close.vue";
import FacebookIcon from "@/components/icons/FacebookIcon.vue";
import Instgramdisactive from "@/components/icons/Instgramdisactive.vue";
import InstgramIcon from "@/components/icons/InstgramIcon.vue";
import Linkicon from "@/components/icons/Linkicon.vue";
import Snapactive from "@/components/icons/Snapactive.vue";
import Snapdisactive from "@/components/icons/Snapdisactive.vue";

export default {
  components: {
    ImageMenu,
    Close,
    FacebookIcon,
    Instgramdisactive,
    InstgramIcon,
    Linkicon,
    Snapactive,
    Snapdisactive,
  },

  data() {
    return {
      tyty: "@/assets/soft-ware-img/Component63.svg",
      isBlue: false,
      isBluei: false,
      tab: null,
      showEmojiPicker: false,
      longOfText: 0,
      newLinkName: "",
      newLinkHref: "",
      links: [],
      enterPostlink: false,
      all_post_dialog: false,
      all_reel_story_dialog: false,
      facebook_post_dialog: false,
      facebook_story_dialog: false,
      facebook_reel_dialog: false,
      instagram_post_dialog: false,
      instagram_story_dialog: false,
      instagram_reel_dialog: false,
      snapchat_post_dialog: false,
      snapchat_story_dialog: false,

      imagePreview: null,
      cursorPosition: 0,
      allPostContent: "",
      allReelStoryContent: "",
      facebookPostContent: "",
      instagramPostContent: "",
      snapChatPostContent: "",
      facebookStoryContent: "",
      facebookReelContent: "",
      instagramStoryContent: "",
      instagramReelContent: "",
      snapChatStoryContent: "",
      store: publishPost(),
    };
  },
  computed: {
    selectedTypes() {
      return this.store.getSelectedTypes;
    },
    ...mapState(publishPost, [
      "storyContant",
      "mediaFilsPost",
      "facebookPostMedia",
      "instagramPostMedia",
      "snapChatPostMedia",
      "facebookStoryMedia",
      "facebookReelMedia",
      "instagramStoryMedia",
      "instagramReelMedia",
      "snapChatStoryMedia",
    ]),
  },
  methods: {
    handleTabClicknf() {
      this.$nextTick(() => {
        const tabEl = this.$refs.facebookTab;
        if (tabEl && tabEl.$el?.classList.contains("v-tab-item--selected")) {
          this.isBlue = true;
        } else {
          this.isBlue = false;
        }
      });
    },
    handleTabClickin() {
      // Check if tab has class `v-tab-item--selected` on click
      const tabEl = this.$refs.instagramTab;
      if (tabEl && tabEl.$el?.classList.contains("v-tab-item--selected")) {
        this.isBluei = true;
      } else {
        this.isBluei = false;
      }
    },
    toggleEmojiPicker() {
      this.showEmojiPicker = !this.showEmojiPicker;
    },
    onEmojiClick(event, x) {
      const emoji = event.detail.unicode;
      const textarea = this.$refs.textarea;
      const start = textarea.selectionStart;
      const end = textarea.selectionEnd;
      switch (x) {
        case "allPostContent":
          this.allPostContent =
            this.allPostContent.substring(0, start) +
            emoji +
            this.allPostContent.substring(end);
          break;
        case "allReelStoryContent":
          this.allReelStoryContent =
            this.allReelStoryContent.substring(0, start) +
            emoji +
            this.allReelStoryContent.substring(end);
          break;
        case "facebookPostContent":
          this.facebookPostContent =
            this.facebookPostContent.substring(0, start) +
            emoji +
            this.facebookPostContent.substring(end);
          break;
        case "instagramPostContent":
          this.instagramPostContent =
            this.instagramPostContent.substring(0, start) +
            emoji +
            this.instagramPostContent.substring(end);
          break;
        case "snapChatPostContent":
          this.snapChatPostContent =
            this.snapChatPostContent.substring(0, start) +
            emoji +
            this.snapChatPostContent.substring(end);
          break;
        case "facebookStoryContent":
          this.facebookStoryContent =
            this.facebookStoryContent.substring(0, start) +
            emoji +
            this.facebookStoryContent.substring(end);
          break;
        case "facebookReelContent":
          this.facebookReelContent =
            this.facebookReelContent.substring(0, start) +
            emoji +
            this.facebookReelContent.substring(end);
          break;
        case "instagramStoryContent":
          this.instagramStoryContent =
            this.instagramStoryContent.substring(0, start) +
            emoji +
            this.instagramStoryContent.substring(end);
          break;
        case "instagramReelContent":
          this.instagramReelContent =
            this.instagramReelContent.substring(0, start) +
            emoji +
            this.instagramReelContent.substring(end);
          break;
        case "snapChatStoryContent":
          this.snapChatStoryContent =
            this.snapChatStoryContent.substring(0, start) +
            emoji +
            this.snapChatStoryContent.substring(end);
          break;
      }
      this.$nextTick(() => {
        textarea.selectionStart = textarea.selectionEnd = start + emoji.length;
        textarea.focus();
      });
      this.showEmojiPicker = false;
    },
    addCustomizationLink(type) {
      if (this.newLinkName && this.newLinkHref) {
        this.postContent += ` ${this.newLinkName}`;
        const linkHTML = `<a href="${this.newLinkHref}" target="_blank">${this.newLinkName}</a>`;
        // this.allPostContent += ` ${this.newLinkName}`;
        // this.allReelStoryContent += ` ${this.newLinkName}`;
        this.enterPostlink = false;
        this.links.push({
          name: this.newLinkName,
          href: this.newLinkHref,
        });
        switch (type) {
          case "all_posts":
            this.store.UpdatePlatformLinks(
              "customize",
              "",
              "post",
              this.newLinkHref,
              this.newLinkName
            );
            break;
          case "all_story_reel":
            this.store.UpdatePlatformLinks(
              "customize",
              "",
              "reel",
              this.newLinkHref,
              this.newLinkName
            );
            this.store.UpdatePlatformLinks(
              "customize",
              "",
              "story",
              this.newLinkHref,
              this.newLinkName
            );
            break;
          case "facebook_post":
            this.store.UpdatePlatformLinks(
              "customize",
              "facebook",
              "post",
              this.newLinkHref,
              this.newLinkName
            );
            break;
          case "facebook_story":
            this.store.UpdatePlatformLinks(
              "customize",
              "facebook",
              "story",
              this.newLinkHref,
              this.newLinkName
            );
            break;
          case "facebook_reel":
            this.store.UpdatePlatformLinks(
              "customize",
              "facebook",
              "reel",
              this.newLinkHref,
              this.newLinkName
            );
            break;
          case "instagram_post":
            this.store.UpdatePlatformLinks(
              "customize",
              "instagram",
              "post",
              this.newLinkHref,
              this.newLinkName
            );
            break;
          case "instagram_story":
            this.store.UpdatePlatformLinks(
              "customize",
              "instagram",
              "story",
              this.newLinkHref,
              this.newLinkName
            );
            break;
          case "instagram_reel":
            this.store.UpdatePlatformLinks(
              "customize",
              "instagram",
              "reel",
              this.newLinkHref,
              this.newLinkName
            );
            break;
          case "snapchat_story":
            this.store.UpdatePlatformLinks(
              "customize",
              "snapchat",
              "story",
              this.newLinkHref,
              this.newLinkName
            );
            break;
          default:
            break;
        }
        this.newLinkName = "";
        this.newLinkHref = "";
      } else {
        alert("Please provide both link name and URL.");
      }
    },
    removeLink(index, platformsfor, platform, typeKey) {
      this.links.splice(index, 1);
      if (typeKey === "story_and_reel") {
        this.store.RemovePlatformLinks(platformsfor, platform, "story");
        this.store.RemovePlatformLinks(platformsfor, platform, "reel");
      } else {
        this.store.RemovePlatformLinks(platformsfor, platform, typeKey);
      }
    },

    handleFileSelected(res, typeOfSocilaMedia) {
      switch (typeOfSocilaMedia) {
        case "allPostContent":
          this.mediaFilsPost.push(res[0]);
          this.store.updatePlatformFile("customize", "", "post", res[0]);
          break;
        case "allReelStoryContent":
          this.mediaFilsPost.push(res[0]);
          this.store.updatePlatformFile("customize", "", "reel", res[0]);
          this.store.updatePlatformFile("customize", "", "story", res[0]);
          break;
        case "facebookPostContent":
          this.facebookPostMedia.push(res[0]);
          this.store.updatePlatformFile(
            "customize",
            "facebook",
            "post",
            res[0]
          );

          break;
        case "instagramPostContent":
          this.instagramPostMedia.push(res[0]);
          this.store.updatePlatformFile(
            "customize",
            "instagram",
            "post",
            res[0]
          );
          break;
        case "snapChatPostContent":
          this.snapChatPostMedia.push(res[0]);
          this.store.updatePlatformFile(
            "customize",
            "snapchat",
            "post",
            res[0]
          );

          break;
        case "facebookStoryContant":
          this.facebookStoryMedia.push(res[0]);
          this.store.updatePlatformFile(
            "customize",
            "facebook",
            "story",
            res[0]
          );

          break;
        case "facebookReelContent":
          this.facebookReelMedia.push(res[0]);
          this.store.updatePlatformFile(
            "customize",
            "facebook",
            "reel",
            res[0]
          );

          break;
        case "instagramStoryContent":
          this.instagramStoryMedia.push(res[0]);
          this.store.updatePlatformFile(
            "customize",
            "instagram",
            "story",
            res[0]
          );

          break;
        case "instagramReelContent":
          this.instagramReelMedia.push(res[0]);
          this.store.updatePlatformFile(
            "customize",
            "instagram",
            "reel",
            res[0]
          );

          break;
        case "snapchatStoryContent":
          this.snapchatStoryMedia.push(res[0]);
          this.store.updatePlatformFile(
            "customize",
            "snapchat",
            "story",
            res[0]
          );

          break;
      }
    },

    removeImage(index, array) {
      array.splice(index, 1);
    },
    fetchLocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const { latitude, longitude } = position.coords;
            this.reverseGeocode(latitude, longitude);
          },
          (error) => {
            console.error("Error fetching location: ", error.message);
            this.allPostContent = "Unable to fetch location.";
          }
        );
      } else {
        this.city = "Geolocation is not supported by this browser.";
      }
    },
    async reverseGeocode(lat, lng) {
      const apiKey = "AIzaSyDZjKonZH3dbzAWQL7P74hu7Pddbd76P6I";
      const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${apiKey}`;

      try {
        const response = await fetch(url);
        const data = await response.json();

        if (data.results && data.results.length > 0) {
          const addressComponents = data.results[0].address_components;
          const cityComponent = addressComponents.find((component) =>
            component.types.includes("locality")
          );

          this.allPostContent = cityComponent
            ? cityComponent.long_name
            : "City not found.";
        } else {
          this.allPostContent = "Unable to fetch city.";
        }
      } catch (error) {
        console.error("Error reverse geocoding: ", error);
        this.allPostContent = "Error fetching city.";
      }
    },
    customizeByPlatformType() {
      this.$emit("customizeByPlatformType", this.customizeByPlatformType);
    },
    ...mapState(publishPost, ["UpdatePlatformContents"]),
  },
  watch: {
    allPostContent(newContent) {
      this.store.UpdatePlatformContents("customize", null, "post", newContent);
      this.longOfText = newContent.length;
    },
    allReelStoryContent(newContent) {
      this.store.UpdatePlatformContents("customize", null, "reel", newContent);
      this.store.UpdatePlatformContents("customize", null, "story", newContent);
      this.longOfText = newContent.length;
    },
    facebookPostContent(newContent) {
      this.store.UpdatePlatformContents(
        "customize",
        "facebook",
        "post",
        newContent
      );
    },
    instagramPostContent(newContent) {
      this.store.UpdatePlatformContents(
        "customize",
        "instagram",
        "post",
        newContent
      );
    },
    snapChatPostContent(newContent) {
      this.store.UpdatePlatformContents(
        "customize",
        "snapchat",
        "post",
        newContent
      );
    },
    facebookStoryContent(newContent) {
      this.store.UpdatePlatformContents(
        "customize",
        "facebook",
        "story",
        newContent
      );
    },
    facebookReelContent(newContent) {
      this.store.UpdatePlatformContents(
        "customize",
        "facebook",
        "reel",
        newContent
      );
    },
    instagramStoryContent(newContent) {
      this.store.UpdatePlatformContents(
        "customize",
        "instagram",
        "story",
        newContent
      );
    },
    instagramReelContent(newContent) {
      this.store.UpdatePlatformContents(
        "customize",
        "instagram",
        "reel",
        newContent
      );
    },
    snapChatStoryContent(newContent) {
      this.store.UpdatePlatformContents(
        "customize",
        "snapchat",
        "story",
        newContent
      );
    },
  },
  mounted() {},
};
</script>

<style scoped>
.emoji-picker-wrapper {
  /* position: absolute; */

  left: 0;
  z-index: 1000;
  margin-bottom: 8px;
}

emoji-picker {
  --num-columns: 8;
  width: 320px;
  height: 400px;
}
.image-preview-overlay {
  position: absolute;
  bottom: 50px;
  height: 40px;
  overflow: auto;
  width: 90%;
}
.image-preview-overlay .image-preview-container {
  display: flex;
  align-items: center;
  gap: 20px;
}
.image-preview-overlay .image-preview-container img {
  width: 40px;
  height: 40px;
  border-radius: 5px;
  object-fit: cover;
  fill: currentColor;
}

.v-tap svg {
  width: 1.3rem;
  height: 1.3rem;
}
.post-card .v-btn__content svg {
  width: 1.4rem;
  height: 1.4rem;
}
</style>
